import { MaterialsProps } from '@domain/discipline'

export const isMediaMaterial = (material: MaterialsProps): boolean => {
  return !!material?.contentStream
}
